import { IShowNotification } from "../models";
import { SHOW_NOTIFICATION } from "../types";

export default (message: string, severity: string): IShowNotification => ({
    type: SHOW_NOTIFICATION,
    payload: {
        message,
        severity,
    },
});
